<template>
    <v-card>
    <v-card-title>
      Lista de registros
      <v-spacer></v-spacer>
       
      <v-text-field
        v-model="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
            v-model="selected"
            :single-select="singleSelect"
            :search="search"
            :headers="headerss"
            :items="table"
            :items-per-page="cant?cant:10"
            class="elevation-4"
            item-key="id"
            :loading="loading"
            @click:row="selectItem"
            show-select
            no-data-text="no hay datos"
            no-results-text="no data"
            loading-text="cargando datos ..."
    >

      <template v-slot:item.alerta="{ item }">
         <v-chip :color="getColor(item.alerta)" dark>
             <v-avatar>
                <v-icon v-if="item.alerta == null">mdi-check</v-icon>
                <v-icon v-else>mdi-information-outline</v-icon>
             </v-avatar>
         </v-chip>
      </template>

    </v-data-table> 
  </v-card>
</template>




<script>
    export default {


    props:{

    table:'',
    headerss:'',
    loadings:'',
    type:'',
    cant:'',
    headerss2:'',

},

methods: {
  
  getColor:function(calories) {
        console.log(calories);
        if (calories == null) return 'green'
        else if (calories) return 'orange'
        else return 'green'
      },

  selectItem:function(value){
    this.$store.dispatch('selectTableAction', {'type':this.type ,'valor':value});
    this.$store.dispatch('asidebarRegistro', true);
  }

},

    data () {
      return {
        singleSelect:false,
        selected:[],
        search: '',


        
         
      }
    },


  watch: {
    selected(){
      this.$store.dispatch('asidebarRegistro', false);
      return this.$store.dispatch('ActionSelectRegisterPdf', this.selected)
    },
  
  
  
  },

  

  computed: {
    reportepdf(){

      //return this.$store.dispatch.

    },
    loading() {
      return this.$store.state.loading_dashboard
    },
  },

  }
</script>